export default __webpack_public_path__ + "locales/tr/ChangeUserTypeDialog.json?hash=d4ca654ea2f1a5021281e1f7adabaf40";